export default {
  data() {
    return {
      wechatQRCodeLink: ""
    };
  },
  methods: {
    async getQrcodeImage() {
      try {
        const res = await this.$axios.getQrcodeImage();
        if (res.code == 1) {
          this.wechatQRCodeLink = res.data.qrcode_info.url;
        }
      } catch (error) {
        console.error(error);
      }
    }
  }
};